var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F68922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40501 5.66876C9.40501 5.66876 7.08357 6.00964 6.74551 8.58982C6.74551 8.58982 6.38664 11.4777 9.33751 12.2573C9.54186 12.311 9.75229 12.338 9.96357 12.3378H10.1087C10.4091 12.3378 10.6971 12.4581 10.9097 12.6719C11.1223 12.8856 11.2416 13.1759 11.2416 13.4785C11.2436 13.765 11.137 14.0415 10.9433 14.2526C10.7496 14.4636 10.4831 14.5934 10.1976 14.6159C8.74689 14.7138 6.80007 14.0016 5.5367 12.2894C5.5367 12.2894 3.06226 8.73157 5.75889 5.46232C6.39524 4.68513 7.22498 4.08916 8.1647 3.73432C9.27282 3.31976 10.8962 3.05314 12.3053 4.15957C12.3053 4.15957 14.1913 5.62039 13.2244 8.00539C13.2244 8.00539 12.5471 9.90382 10.2263 10.0501L9.90395 10.0321C9.75126 10.0281 9.60123 9.99126 9.464 9.9242C9.32677 9.85714 9.20556 9.76137 9.10857 9.64339C9.01112 9.52489 8.94001 9.38702 8.89995 9.23893C8.8599 9.09083 8.85182 8.93591 8.87626 8.78445C8.91522 8.53857 9.03862 8.31394 9.22525 8.14917C9.41188 7.98441 9.65007 7.88981 9.89889 7.88164L10.2263 7.85914C10.2263 7.85914 11.3383 7.81076 11.2416 6.4962C11.2416 6.4962 11.1448 5.32789 9.40445 5.66932",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqua);
export default __webpack_public_path__ + "static/media/equa.a7b0252eeebe33121a3140bc1f157e60.svg";
export { ForwardRef as ReactComponent };